import MirsTable from "components/general/table/Table";
import Competitors from "components/presentation/Competitor"
import Noc from "components/presentation/Noc";
import { ResultCompetitor } from 'components/presentation/ResultRank'
import { useMemo } from "react";
import CaptionTable from "components/general/table/CaptionTable";
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const CrdRaceFacts = ({ data, numRows }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    let actions
    if (numRows) {
        actions = data?.results?.playByPlay && data?.results?.playByPlay[0].actions.sort((a, b) => b.pbpa_order - a.pbpa_order).slice(0, numRows)
    } else {
        actions = data?.results?.playByPlay && data?.results?.playByPlay[0].actions.sort((a, b) => a.pbpa_order - b.pbpa_order)
    }

    const resultsItems = data?.results?.items


    const tableColumns = useMemo(() =>
        [
            {
                id: "id1",
                Header: "When",
                accessor: 'pbpa_period',
            },
            {
                id: "id2",
                Header: "Fact",
                headerClassName: "text-start",
                accessor: 'pbpa_ActionDesc',
                className: "text-start"
            },
            {
                id: "id3",
                Header: "Riders involved",
                headerClassName: "text-start",
                accessor: 'pbpa_order',
                className: "text-start",
                Cell: (props) => {

                    const competitors = props.cell.row.original?.competitors?.map((competitor, key) =>
                        competitor.athletes.map((athlete, key) => {

                            //let athleteItem = findArray (resultsItems.participant, {code:[athlete.pbpat_code]})
                            let athleteItem = resultsItems?.find(item => item.participant.code === athlete.pbpat_code)
                            return (
                                <ResultCompetitor
                                    key={`Athlete-Involved-${key}`}
                                    bib={athleteItem?.bib}
                                    noc={<Noc code={athleteItem?.participant?.organisation?.code} />}
                                    competitor={<Competitors
                                        name={athleteItem?.participant?.name}
                                        shortName={athleteItem?.participant?.shortName}
                                        hidePicture={true}
                                        noc={athleteItem?.participant?.organisation?.code}
                                        code={athleteItem?.participant?.code}
                                    />} />
                            )
                        }
                        )
                    );
                    return (
                        <>
                            {competitors}
                        </>
                    );



                }
            }
        ], []);

    const captionTable = <CaptionTable leftCol={<Label data="HeaderRaceFacts" />} />

    return (
        <>
            {actions &&
                < MirsTable
                    className='table-result'
                    data={actions}
                    columns={tableColumns}
                    id={`mirs-table-race-facts-${mirs_rsc}`}
                    caption={captionTable}
                />
            }
        </>
    )



};
export default CrdRaceFacts;